import axios from "axios";
import { baseUrl, getConfig } from "../config";
import Swal from "sweetalert2";

export const fetchMembers = () => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/API/getallusers`,
			getConfig(getState)
		);
		dispatch({ type: "GET_MEMBERS", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const findUserBySearch = (params) => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/API/searchmembers?${params}`,
			getConfig(getState)
		);
		const showModal = true;
		dispatch({ type: "GET_MEMBERS_SEARCH", payload: res.data });
		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data, showModal });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const getUserById = (id) => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/API/getmember/${id}`,
			getConfig(getState)
		);

		dispatch({ type: "GET_MEMBER_BY_ID", payload: res.data });
		// dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const getUserByMemberId = (id) => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/user/getmemberbymemberid/${id}`,
			getConfig(getState)
		);

		dispatch({ type: "GET_MEMBER_BY_ID", payload: res.data });
		// dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const updateFeatureToggle = (userId, feature, enabled) => async (dispatch, getState) => {
	try {
		const res = await axios.patch(
			`${baseUrl}/admin/${userId}/feature-toggle`,
			{ featureName: feature, status: enabled },
			getConfig(getState)
		);
		dispatch({ type: "UPDATE_MEMBER_FEATURE_TOGGLE", payload: res.data });
		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};


export const newRegistrations = () => async (dispatch, getState) => {
	try {
		dispatch({ type: "SET_LOADING" });
		const res = await axios.get(
			`${baseUrl}/admin/API/newregistration`,
			getConfig(getState)
		);

		dispatch({ type: "NEW_REGISTRATION", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const fetchReferrals = () => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/api/getreferals`,
			getConfig(getState)
		);
		dispatch({ type: "GET_REFERRALS", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const confirmUser = (id) => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/API/confirm/${id}`,
			getConfig(getState)
		);

		dispatch({ type: "CONFIRM_USER_SUCCESSFUL", payload: res.data });
		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const deleteUser = (id) => async (dispatch, getState) => {
	try {
		const res = await axios.delete(
			`${baseUrl}/admin/API/deleteuser`,
			{
				...getConfig(getState),
				data: { id },
			}
		);
		dispatch({ type: "DELETE_USER_SUCCESSFUL", payload: res.data });
		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};


export const acknowledgeReciept =
	(userdata, type) => async (dispatch, getState) => {
		try {
			let res;
			if (type === "initial") {
				res = await axios.post(
					`${baseUrl}/admin/API/acknowledgereciept`,
					{ userdata },
					getConfig(getState)
				);
			}
			if (type === "increase") {
				res = await axios.post(
					`${baseUrl}/admin/API/acknowledgeincreasereciept`,
					{ userdata },
					getConfig(getState)
				);
			}
			if (type === "decrease") {
				res = await axios.post(
					`${baseUrl}/admin/API/acknowledgedecreasereciept`,
					{ userdata },
					getConfig(getState)
				);
			}
			dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
		} catch (err) {
			dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
		}
	};

export const declineReciept = (userdata) => async (dispatch, getState) => {
	try {
		const res = await axios.post(
			`${baseUrl}/admin/API/declinereciept`,
			{ userdata },
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const sendEmail = (data) => async (dispatch, getState) => {
	try {
		const res = await axios.post(
			`${baseUrl}/admin/API/sendemail`,
			data,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR", payload: err.response?.data });
	}
};

export const wakeup = () => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/API/getmembers`,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR", payload: err.response?.data });
	}
};

export const addFinacialReport = (data) => async (dispatch, getState) => {
	try {
		const res = await axios.post(
			`${baseUrl}/admin/API/add-fin-report`,
			data,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const getFinReport = () => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/API/get-fin-report`,

			getConfig(getState)
		);

		dispatch({ type: "GET_FIN_REPORT", payload: res.data.finReports });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const deleteFinReport = (id) => async (dispatch, getState) => {
	try {
		const res = await axios.delete(
			`${baseUrl}/admin/API/delete-fin-report/${id}`,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const addLegalDoc = (data) => async (dispatch, getState) => {
	try {
		const res = await axios.post(
			`${baseUrl}/admin/API/add-legal-doc`,
			data,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const getLegalDocs = () => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/API/get-legal-doc`,

			getConfig(getState)
		);

		dispatch({ type: "GET_LEGAL_DOC", payload: res.data.legalDoc });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const deleteLegalDoc = (id) => async (dispatch, getState) => {
	try {
		const res = await axios.delete(
			`${baseUrl}/admin/API/delete-legal-doc/${id}`,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};
export const addProduct = (data) => async (dispatch, getState) => {
	try {
		const res = await axios.post(
			`${baseUrl}/admin/API/addproduct`,
			data,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};
export const updateProduct = (data) => async (dispatch, getState) => {
	try {
		const res = await axios.post(
			`${baseUrl}/admin/API/updateproduct`,
			data,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const updateBankDetails = (id, data) => async (dispatch, getState) => {
	try {
		const res = await axios.put(
			`${baseUrl}/admin/API/update-bank-details/${id}`,
			data,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
		dispatch({
			type: "UPDATED_BANK_INFO",
			payload: res.data.bankDetails,
		});
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};
export const getProducts = () => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/API/getproducts`,
			getConfig(getState)
		);

		dispatch({ type: "GET_PRODUCTS", payload: res.data });
	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};

export const removeProducts = (id) => async (dispatch, getState) => {
	try {
		const res = await axios.delete(
			`${baseUrl}/admin/API/removeproducts`,
			{
				headers: {
					Content_Type: "application/json",
				},
				data: {
					id,
				},
			},

			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};

export const fetchCommodityReq = () => async (dispatch, getState) => {
	try {
		const res = await axios.get(
			`${baseUrl}/admin/API/commodityrequests`,
			getConfig(getState)
		);

		dispatch({ type: "GET_COMMODITY_REQUEST", payload: res.data });
	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};

export const fetchCommodityReqv2 = (status, page = 1, search = "") => async (dispatch, getState) => {
	try {
		dispatch({ type: "SET_LOADING_TRUE" });
		const res = await axios.get(
			`${baseUrl}/admin/v2/commodityrequests?status=${status}&page=${page}&search=${search}`,
			getConfig(getState)
		)

		dispatch({ type: "GET_COMMODITY_REQUEST", payload: { status, data: res.data } });

	} catch (err) {
		dispatch({ type: "SET_LOADING_FALSE" });
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};



export const updateCommodityReqStatus = (id, status) => async (dispatch, getState) => {
	try {
		dispatch({ type: "SET_LOADING_TRUE" });

		const res = await axios.put(
			`${baseUrl}/admin/API/updatecommodityrequeststatus/${id}`,
			{ status },
			getConfig(getState)
		);

		Swal.fire({
			icon: "success",
			text: "action successful",
			showConfirmButton: false,
		})

		dispatch(fetchCommodityReqv2("pending", 1));
	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data || "An error occurred while updating the request status.",
		});
	} finally {
		dispatch({ type: "SET_LOADING_FALSE" });
	}
};

export const deleteCommodityReq = (id) => async (dispatch, getState) => {
	try {
		const res = await axios.delete(
			`${baseUrl}/admin/API/removerequest`,
			{
				headers: {
					Content_Type: "application/json",
				},
				data: {
					id,
				},
			},

			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};

export const fetchSavingsWithdrawalRequests = (params) => async (dispatch, getState) => {

	try {
		const { page = 1, status, search } = params;
		let url = `/admin/withdrawal-requests?page=${page}`;

		if (status) url += `&status=${status}`;
		if (search) url += `&search=${search}`;
		const res = await axios.get(`${baseUrl}${url}`, getConfig(getState));

		dispatch({ type: "GET_SAVINGS_WITHDRAWAL_REQUESTS", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const fetchMemberWithdrawalRequests = (params) => async (dispatch, getState) => {
	try {
		const { page = 1, status, search } = params;
		let url = `/admin/member-withdrawal-requests?page=${page}`;

		if (status) url += `&status=${status}`;
		if (search) url += `&search=${search}`;
		const res = await axios.get(`${baseUrl}${url}`, getConfig(getState));
		console.log(res)
		dispatch({ type: "GET_MEMBER_WITHDRAWAL_REQUESTS", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
};

export const fetchLandAcquisitionRequests = (params) => async (dispatch, getState) => {

	try {
		const { page = 1, status, search, memberType } = params;
		let url = `/admin/land-acquisition-requests?page=${page}`;

		if (status) url += `&status=${status}`;
		if (search) url += `&search=${search}`;
		if (memberType) url += `&memberType=${memberType}`;

		const res = await axios.get(`${baseUrl}${url}`, getConfig(getState));
		dispatch({ type: "GET_LAND_ACQUISITION_REQUESTS", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
}

export const fetchSystemConfigs = () => async (dispatch, getState) => {
	try {
		dispatch({ type: "SET_LOADING_TRUE" });
		const res = await axios.get(
			`${baseUrl}/api/system-configs`, getConfig(getState)
		);

		dispatch({ type: "GET_SYSTEM_CONFIGS", payload: res.data });
	}
	catch (err) {
		dispatch({ type: "SET_LOADING_FALSE" });
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
}

export const updateSystemConfig = (data) => async (dispatch, getState) => {
	try {
		dispatch({ type: "SET_LOADING_TRUE" });
		const res = await axios.put(
			`${baseUrl}/admin/update-system-configs`, data, getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({ type: "SET_LOADING_FALSE" });
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
}


// export const updateSavingsWithdrawal = (params) => async (dispatch, getState) => {
// 	try {
// 		const res = await axios.put(`${baseUrl}/admin/API/update-savings-withdrawal/${params.userId}`, data, getConfig(getState));
// 		dispatch({ type: "UPDATE_SAVINGS_WITHDRAWAL", payload: res.data });

// 	} catch (err) {
// 		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
// 	}
// };

// export const updateMemberWithdrawal = (id, data) => async (dispatch, getState) => {
// 	try {
// 		const res = await axios.put(`${baseUrl}/admin/API/update-member-withdrawal/${id}`, data, getConfig(getState));
// 		dispatch({ type: "UPDATE_MEMBER_WITHDRAWAL", payload: res.data });
// 		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
// 		dispatch(fetchMemberWithdrawalRequests({ page: 1, status: "pending" }));
// 	} catch (err) {
// 		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
// 	}
// };


export const fetchLoanRequest = (page) => async (dispatch, getState) => {
	try {
		dispatch({ type: "SET_LOADING_TRUE" })
		const res = await axios.get(
			`${baseUrl}/admin/API/loanrequest?page=${page}`,
			getConfig(getState)
		);

		dispatch({ type: "SET_LOADING_FALSE" })

		dispatch({ type: "GET_LOAN_REQUEST", payload: res.data });
	} catch (err) {
		dispatch({ type: "SET_LOADING_FALSE" })
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};

export const searchLoanRequests = (searchTerm, page = 1) => async (dispatch, getState) => {
	try {
		dispatch({ type: "SET_LOADING_TRUE" });

		// Encode the search term to handle special characters
		const encodedSearchTerm = encodeURIComponent(searchTerm.trim());

		const res = await axios.get(
			`${baseUrl}/admin/API/loanrequest/search?q=${encodedSearchTerm}&page=${page}`,
			getConfig(getState)
		);

		dispatch({ type: "SET_LOADING_FALSE" });

		// Use the same action type as fetchLoanRequest since the response format is identical
		dispatch({
			type: "GET_LOAN_REQUEST",
			payload: {
				loanRequests: res.data.loanRequests,
				numberOfPages: res.data.numberOfPages,
				message: res.data.message
			}
		});
	} catch (err) {
		dispatch({ type: "SET_LOADING_FALSE" });
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};

export const fetchMemberBalance = (id) => async (dispatch, getState) => {
	try {
		dispatch({ type: "SET_LOADING_TRUE" })
		const res = await axios.get(
			`${baseUrl}/user/get-balances?id=${id}`,
			getConfig(getState)
		);

		dispatch({ type: "SET_LOADING_FALSE" })

		dispatch({ type: "GET_MEMBER_BALANCE", payload: res.data });
	} catch (err) {
		dispatch({ type: "SET_LOADING_FALSE" })
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};

export const updateSavingsWithdrawalRequest = (params) => async (dispatch, getState) => {

	try {

		const res = await axios.put(
			`${baseUrl}/admin/update-savings-withdrawal/${params.requestId}`,
			params.updateData,
			getConfig(getState)
		);

		dispatch({ type: "UPDATE_SAVINGS_WITHDRAWAL", payload: res.data.request });



	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
}

export const updateMemberWithdrawalRequest = (params) => async (dispatch, getState) => {


	try {
		const res = await axios.put(
			`${baseUrl}/admin/update-member-withdrawal/${params.requestId}`,
			params.updateData,
			getConfig(getState)
		);


		dispatch({ type: "UPDATE_MEMBER_WITHDRAWAL", payload: res.data.request });

	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
}

export const updateLandAcquisitionRequest = (params) => async (dispatch, getState) => {
	try {
		const res = await axios.put(
			`${baseUrl}/admin/update-land-acquisition/${params.requestId}`,
			params,
			getConfig(getState)
		);


		dispatch({ type: "UPDATE_LAND_ACQUISITION", payload: res.data.request });

	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
}

export const getBeneficiaryRequests = (params) => async (dispatch, getState) => {
	try {
		const { page = 1, status, search } = params;
		let url = `/admin/beneficiary-requests?page=${page}`;

		if (status) url += `&status=${status}`;
		if (search) url += `&search=${search}`;
		const res = await axios.get(`${baseUrl}${url}`, getConfig(getState));
		dispatch({ type: "GET_BENEFICIARY_REQUESTS", payload: res.data });
	} catch (err) {
		dispatch({ type: "GET_ERROR_MSG", payload: err.response?.data });
	}
}

export const updateBeneficiaryRequest = (params) => async (dispatch, getState) => {
	try {
		const res = await axios.put(
			`${baseUrl}/admin/update-beneficiary/${params.requestId}`,
			params,
			getConfig(getState)
		);


		dispatch({ type: "UPDATE_BENEFICIARY_REQUEST", payload: res.data.request });

	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
}


export const fetchApprovedLoanRequest = (page, search = "") => async (dispatch, getState) => {
	try {
		dispatch({ type: "SET_LOADING_TRUE" });

		const res = await axios.get(
			`${baseUrl}/admin/API/approvedloan?page=${page}&search=${encodeURIComponent(search)}`,
			getConfig(getState)
		);

		if (res.data?.loanRequests.length === 0) {
			Swal.fire({
				icon: 'info',
				title: 'No Loans Found',
				text: 'There are currently no approved loan requests.',
			});
		}

		dispatch({ type: "SET_LOADING_FALSE" });

		dispatch({ type: "GET_LOAN_REQUEST", payload: res.data });
	} catch (err) {
		dispatch({ type: "SET_LOADING_FALSE" });
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};


export const acknowledgeLoanRequest = (data) => async (dispatch, getState) => {
	try {
		const res = await axios.put(
			`${baseUrl}/admin/API/acceptloanreq`,
			data,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};

export const rejectLoanRequest = (id) => async (dispatch, getState) => {
	try {
		let data = {
			id: id,
		};
		const res = await axios.post(
			`${baseUrl}/admin/API/rejectloanreq`,
			data,
			getConfig(getState)
		);

		dispatch({ type: "GET_SUCCESS_MSG", payload: res.data });
	} catch (err) {
		dispatch({
			type: "GET_ERROR_MSG",
			payload: err?.response?.data,
		});
	}
};
